import { c as _c } from "react/compiler-runtime";
import type { Icon } from '@onefootprint/icons';
import { IcoClock24, IcoLayer0124, IcoSmartphone224, IcoSquareFrame24 } from '@onefootprint/icons';
import { useTranslation } from 'react-i18next';
import type { AutoCaptureKind } from '../../../camera/types';
export type InstructionItem = {
  title: string;
  description: string;
  Icon: Icon;
};
const useInstructionItems = (autoCaptureKind, autocapture) => {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "document-flow.components.photo-capture.instructions"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t0);
  const captureKind = autoCaptureKind === "face" ? "face" : "document";
  let items;
  if ($[1] !== autocapture || $[2] !== captureKind || $[3] !== t) {
    items = [{
      title: captureKind === "face" ? t(_temp) : t(_temp2),
      description: captureKind === "face" ? t(_temp3) : t(_temp4),
      Icon: IcoSquareFrame24
    }, {
      title: t(_temp5),
      description: t(_temp6),
      Icon: IcoSmartphone224
    }];
    if (autocapture) {
      items.push({
        title: captureKind === "face" ? t(_temp7) : t(_temp8),
        description: captureKind === "face" ? t(_temp9) : t(_temp10),
        Icon: IcoClock24
      });
    }
    if (captureKind === "document") {
      items.unshift({
        title: t(_temp11),
        description: t(_temp12),
        Icon: IcoLayer0124
      });
    }
    $[1] = autocapture;
    $[2] = captureKind;
    $[3] = t;
    $[4] = items;
  } else {
    items = $[4];
  }
  return items;
};
export default useInstructionItems;
function _temp($) {
  return $["position-face"].title;
}
function _temp2($_0) {
  return $_0["position-document"].title;
}
function _temp3($_1) {
  return $_1["position-face"].description;
}
function _temp4($_2) {
  return $_2["position-document"].description;
}
function _temp5($_3) {
  return $_3.steady.title;
}
function _temp6($_4) {
  return $_4.steady.description;
}
function _temp7($_5) {
  return $_5["autocapture-face"].title;
}
function _temp8($_6) {
  return $_6["autocapture-document"].title;
}
function _temp9($_7) {
  return $_7["autocapture-face"].description;
}
function _temp10($_8) {
  return $_8["autocapture-document"].description;
}
function _temp11($_9) {
  return $_9.background.title;
}
function _temp12($_10) {
  return $_10.background.description;
}